<template>
  <div>

  </div>
</template>

<script>
  import {createEditor} from 'vueditor';
  import {editorConfig} from 'src/config/config';
  import {
    CommonUploadModel
  } from 'src/model/CommonModel';

  export default{
    data(){
      return {
        instance: null
      }
    },
    props: {
      value: {
        require: true
      },
      bindid: {
        require: true,
        type: String
      }
    },
    watch: {
      value(val){
        if(this.instance){
          this.instance.setContent(val);
        }
      }
    },
    mounted(){
      this.instance = createEditor(this.bindid, editorConfig);
      this.instance.upload = function(obj, callback){
        let file = obj.files[0];
        CommonUploadModel.getInstance().execute({
          'files[]': file
        }).then(data =>{
          let url = data.list[0].file_url;
          callback(url);
        })
      };
    },

    methods: {
      change(){
        let content = this.instance.getContent();
        this.$emit('input', content);
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Component/VueEditor/index.vue?2e7be65a